"use client";

import { cn } from "@/lib/utils";
import { Tab } from "@headlessui/react";
import Communities from "./tabs/communities";
import CountryPortals from "./tabs/country-portals";
import Image from "next/image";
import Categories from "./tabs/categories";

const PopularTabs = () => {
	const tabs = ["Categories", "Communities", "Country Portals"];

	return (
		<>
			<div className="mt-8 w-full bg-cover bg-no-repeat py-12 sm:mt-16 bg-gradient-radial from-[#d3e2ff] via-[#e0ebff] to-[#fafbff] relative min-h-[28rem]">
				<div className="absolute left-0 top-0 h-full w-1/8 sm:opacity-100 opacity-40">
					<Image src="/images/home/categories-section-left.png"
						alt="Categories Section Left"
						height={400}
						width={400}
						className="h-full w-full object-cover" />
				</div>
				<div className="absolute right-0 top-0 h-full w-1/8 hidden md:block">
					<Image
						src="/images/home/categories-section-right.png"
						alt="Categories Section Right"
						height={400}
						width={400}
						className="h-full w-full object-cover" />
				</div>
				<Tab.Group as="div" className="mx-auto w-11/12 max-w-[49rem] overflow-hidden  lg:w-full">
					<Tab.List className="relative flex justify-center gap-0.5">
						{tabs.map((tabName) => (
							<Tab
								key={tabName}
								className={({ selected }) =>
									cn(
										"w-fit -skew-x-[8deg] px-4 py-3 text-center text-sm font-bold transition-all hover:bg-brand-primary hover:text-white hover:opacity-50 sm:text-lg md:px-6",
										selected
											? "bg-brand-primary text-white outline-none hover:opacity-100"
											: "bg-white font-semibold text-gray-400"
									)
								}
							>
								{tabName}
							</Tab>
						))}
					</Tab.List>
					<Tab.Panel>
						<Categories />	
					</Tab.Panel>
					<Tab.Panels>
						<Tab.Panel>
							<Communities />
						</Tab.Panel>
						<Tab.Panel>
							<CountryPortals />
						</Tab.Panel>
					</Tab.Panels>
				</Tab.Group>
			</div>
		</>
	);
};

export default PopularTabs;
